"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_0.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1126. Curso de Seguridad Ciudadana Avanzada
    {
        id: 1126,
        tax: 0.21,
        sku: "iopos.course.online.curso-seguridad-ciudadana-avanzada-2026",
        title: "Curs de Seguretat Ciutadana Avançada",
        name: "Curs de Seguretat Ciutadana Avançada",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "Formació operativa avançada orientada a capacitar els professionals policials en tècniques, protocols i actuacions complexes de seguretat ciutadana amb ple respecte al marc legal i als principis d’ús de la força.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1126/image1"],
        banner: ["/1126/image1"],
        link: "/tienda/cursos/formacion-policial/curso-seguridad-ciudadana-avanzada/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1127, 1128],
        multiple_languages: false,
    },
    // 1127. Curso de Seguridad Ciudadana Avanzada - ES
    {
        id: 1127,
        tax: 0.21,
        sku: "iopos.course.online.curso-seguridad-ciudadana-avanzada-2026-es",
        title: "Curso de Seguridad Ciudadana Avanzada",
        name: "Curso de Seguridad Ciudadana Avanzada",
        short: "1.) Seguridad Ciudadana Avanzada",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1126/image1"],
        banner: ["/1126/image1"],
        link: "/tienda/cursos/formacion-policial/curso-seguridad-ciudadana-avanzada-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1126,
        evolmind: { course_id: 1186, group_id: [3034] },
    },
    // 1128. Curso de Seguridad Ciudadana Avanzada - CA
    {
        id: 1128,
        tax: 0.21,
        sku: "iopos.course.online.curso-seguridad-ciudadana-avanzada-2026-ca",
        title: "Curs de Seguretat Ciutadana Avançada",
        name: "Curs de Seguretat Ciutadana Avançada",
        short: "1.) Seguretat Ciutadana Avançada",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1126/image1"],
        banner: ["/1126/image1"],
        link: "/tienda/cursos/formacion-policial/curso-seguridad-ciudadana-avanzada-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1126,
        evolmind: { course_id: 1183, group_id: [3031] },
    },
    // 1129. Curso Actuación Policial en Conductas Suicidas
    {
        id: 1129,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-policial-conductas-suicidas-2026",
        title: "Curs d'Actuació Policial en Conductes Suïcides",
        name: "Curs d'Actuació Policial en Conductes Suïcides",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a detectar, prevenir i intervenir amb criteri professional, seguretat jurídica i sensibilitat davant conductes suïcides en l’àmbit policial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1129/image1"],
        banner: ["/1129/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-policial-conductas-suicidas-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1130, 1131],
        multiple_languages: false,
    },
    // 1130. Curso Actuación Policial en Conductas Suicidas - ES
    {
        id: 1130,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-policial-conductas-suicidas-2026-es",
        title: "Curso Actuación Policial en Conductas Suicidas.",
        name: "Curso Actuación Policial en Conductas Suicidas.",
        short: "1.) Actuación Policial en Conductas Suicidas.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1129/image1"],
        banner: ["/1129/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-policial-conductas-suicidas-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1129,
        default_in_parent: true,
        evolmind: { course_id: 931, group_id: [2770] },
    },
    // 1131. Curso Actuación Policial en Conductas Suicidas - CA
    {
        id: 1131,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-policial-conductas-suicidas-2026-ca",
        title: "Curs Actuació Policial en Conductes Suïcides.",
        name: "Curs Actuació Policial en Conductes Suïcides.",
        short: "1.) Actuació Policial en Conductes Suïcides.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1129/image1"],
        banner: ["/1129/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-policial-conductas-suicidas-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1129,
        default_in_parent: true,
        evolmind: { course_id: 928, group_id: [2767] },
    },
    // 1132. Curso Guía Canino
    {
        id: 1132,
        tax: 0.21,
        sku: "iopos.course.online.curso-guia-canino-2026",
        title: "Curs Guia Caní",
        name: "Curs Guia Caní",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació especialitzada orientada a capacitar el professional policial en la gestió integral del gos de treball, garantint el seu benestar, rendiment operatiu i coordinació funcional dins el binomi guia-gos.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1132/image2"],
        banner: ["/1132/image2"],
        link: "/tienda/cursos/formacion-policial/curso-guia-canino-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1133, 1134],
        multiple_languages: false,
    },
    // 1133. Curso Guía Canino - ES
    {
        id: 1133,
        tax: 0.21,
        sku: "iopos.course.online.curso-guia-canino-2026-es",
        title: "Curso Guía Canino",
        name: "Curso Guía Canino",
        short: "1.) Guía Canino.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1132/image2"],
        banner: ["/1132/image2"],
        link: "/tienda/cursos/formacion-policial/curso-guia-canino-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1132,
        default_in_parent: true,
        evolmind: { course_id: 1189, group_id: [3037] },
    },
    // 1134. Curso Guía Canino - CA
    {
        id: 1134,
        tax: 0.21,
        sku: "iopos.course.online.curso-guia-canino-2026-ca",
        title: "Curs Guia Caní",
        name: "Curs Guia Caní",
        short: "1.) Guia Caní",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1132/image2"],
        banner: ["/1132/image2"],
        link: "/tienda/cursos/formacion-policial/curso-guia-canino-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1132,
        default_in_parent: true,
        evolmind: { course_id: 1192, group_id: [3040] },
    },
    // 1135. Curso Especialista en Protección de Personalidades
    {
        id: 1135,
        tax: 0.21,
        sku: "iopos.course.online.curso-especialista-proteccion-personalidades-2026",
        title: "Curs Especialista en Protecció de Personalitats",
        name: "Curs Especialista en Protecció de Personalitats",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació tècnica i operativa orientada a planificar i executar dispositius de protecció de personalitats, integrant marc legal, tècniques d’escorta, protecció d’edificis i resposta davant riscos.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1135/image1"],
        banner: ["/1135/image1"],
        link: "/tienda/cursos/formacion-policial/curso-especialista-proteccion-personalidades-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1136, 1137],
        multiple_languages: false,
    },
    // 1136. Curso Especialista en Protección de Personalidades - ES
    {
        id: 1136,
        tax: 0.21,
        sku: "iopos.course.online.curso-especialista-proteccion-personalidades-2026-es",
        title: "Curso Especialista en Protección de Personalidades",
        name: "Curso Especialista en Protección de Personalidades",
        short: "1.) Especialista en Protección de Personalidades",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1136/image1"],
        banner: ["/1136/image1"],
        link: "/tienda/cursos/formacion-policial/curso-especialista-proteccion-personalidades-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1135,
        default_in_parent: true,
        evolmind: { course_id: 1198, group_id: [3046] },
    },
    // 1137. Curso Especialista en Protección de Personalidades - CA
    {
        id: 1137,
        tax: 0.21,
        sku: "iopos.course.online.curso-especialista-proteccion-personalidades-2026-ca",
        title: "Curs Especialista en Protecció de Personalitats",
        name: "Curs Especialista en Protecció de Personalitats",
        short: "1.) Especialista en Protecció de Personalitats",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1135/image1"],
        banner: ["/1135/image1"],
        link: "/tienda/cursos/formacion-policial/curso-especialista-proteccion-personalidades-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1135,
        default_in_parent: true,
        evolmind: { course_id: 1195, group_id: [3043] },
    },
    // 1138. Curso Medio Ambiente
    {
        id: 1138,
        tax: 0.21,
        sku: "iopos.course.online.curso-medio-ambiente-2026",
        title: "Curs Medi Ambient",
        name: "Curs Medi Ambient",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals policials en la protecció del medi ambient, la prevenció d’infraccions ambientals i la coordinació operativa amb serveis especialitzats.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1138/image1"],
        banner: ["/1138/image1"],
        link: "/tienda/cursos/formacion-policial/curso-medio-ambiente-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1139, 1140],
        multiple_languages: false,
    },
    // 1139. Curso Medio Ambiente - ES
    {
        id: 1139,
        tax: 0.21,
        sku: "iopos.course.online.curso-medio-ambiente-2026-es",
        title: "Curso Medio Ambiente",
        name: "Curso Medio Ambiente",
        short: "1.) Medio Ambiente",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1138/image1"],
        banner: ["/1138/image1"],
        link: "/tienda/cursos/formacion-policial/curso-medio-ambiente-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1138,
        default_in_parent: true,
        evolmind: { course_id: 1201, group_id: [3049] },
    },
    // 1140. Curso Medio Ambiente - CA
    {
        id: 1140,
        tax: 0.21,
        sku: "iopos.course.online.curso-medio-ambiente-2026-ca",
        title: "Curs Medi Ambient",
        name: "Curs Medi Ambient",
        short: "1.) Medi Ambient",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1138/image1"],
        banner: ["/1138/image1"],
        link: "/tienda/cursos/formacion-policial/curso-medio-ambiente-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1138,
        default_in_parent: true,
        evolmind: { course_id: 1204, group_id: [3052] },
    },
    // 1141. Curso Policía Rural I
    {
        id: 1141,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-i-2026",
        title: "Curs Policia Rural I",
        name: "Curs Policia Rural I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals policials en la protecció del medi rural, la normativa ambiental i la vigilància dels recursos naturals a Catalunya.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1141/image1"],
        banner: ["/1141/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-i-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1142, 1143],
        multiple_languages: false,
    },
    // 1142. Curso Policía Rural I - ES
    {
        id: 1142,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-i-2026-es",
        title: "Curso Policía Rural I",
        name: "Curso Policía Rural I",
        short: "1.) Policía Rural I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1141/image1"],
        banner: ["/1141/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-i-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1141,
        default_in_parent: true,
        evolmind: { course_id: 1207, group_id: [3055] },
    },
    // 1143. Curso Policía Rural I - CA
    {
        id: 1143,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-i-2026-ca",
        title: "Curs Policia Rural I",
        name: "Curs Policia Rural I",
        short: "1.) Policia Rural I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1141/image1"],
        banner: ["/1141/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-i-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1141,
        default_in_parent: true,
        evolmind: { course_id: 1210, group_id: [3058] },
    },
    // 1144. Curso Policía Rural II
    {
        id: 1144,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-ii-2026",
        title: "Curs Policia Rural II",
        name: "Curs Policia Rural II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació avançada orientada a aprofundir en la intervenció policial en l’àmbit rural, amb especial incidència en incendis forestals, gestió hídrica, contaminació i protecció del domini públic.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1144/image1"],
        banner: ["/1144/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-ii-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1145, 1146],
        multiple_languages: false,
    },
    // 1145. Curso Policía Rural II - ES
    {
        id: 1145,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-ii-2026-es",
        title: "Curso Policía Rural II",
        name: "Curso Policía Rural II",
        short: "1.) Policía Rural II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1145/image1"],
        banner: ["/1145/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-ii-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1144,
        default_in_parent: true,
        evolmind: { course_id: 1213, group_id: [3061] },
    },
    // 1146. Curso Policía Rural II - CA
    {
        id: 1146,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-ii-2026-ca",
        title: "Curs Policia Rural II",
        name: "Curs Policia Rural II",
        short: "1.) Policia Rural II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1144/image1"],
        banner: ["/1144/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-ii-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1144,
        default_in_parent: true,
        evolmind: { course_id: 1213, group_id: [3061] },
    },
    // 1147. Curso Policía Rural III
    {
        id: 1147,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-iii-2026",
        title: "Curs Policia Rural III",
        name: "Curs Policia Rural III",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació especialitzada avançada orientada a consolidar les competències policials en l’àmbit rural, amb especial incidència en investigació ambiental, coordinació institucional i actuació penal especialitzada.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1147/image1"],
        banner: ["/1147/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-iii-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1148, 1149],
        multiple_languages: false,
    },
    // 1148. Curso Policía Rural III - ES
    {
        id: 1148,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-iii-2026-es",
        title: "Curso Policía Rural III",
        name: "Curso Policía Rural III",
        short: "1.) Policía Rural III",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1148/image1"],
        banner: ["/1148/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-iii-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1147,
        default_in_parent: true,
        evolmind: { course_id: 1219, group_id: [3067] },
    },
    // 1149. Curso Policía Rural III - CA
    {
        id: 1149,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-rural-iii-2026-ca",
        title: "Curs Policia Rural III",
        name: "Curs Policia Rural III",
        short: "1.) Policia Rural III",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1149/image1"],
        banner: ["/1149/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-rural-iii-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1147,
        default_in_parent: true,
        evolmind: { course_id: 1222, group_id: [3070] },
    },
    // 1150. Curso Vigilanca Penitenenciaria, Custodia y Traslados
    {
        id: 1150,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilancia-penitenenciaria-custodia-traslados-2026",
        title: "Curs Vigilància Penitenciària, Custòdia i Trasllats",
        name: "Curs Vigilància Penitenciària, Custòdia i Trasllats",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals policials en vigilància penitenciària, custòdia i trasllats amb criteri jurídic, coordinació institucional i màxima seguretat operativa.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1150/image1"],
        banner: ["/1150/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilancia-penitenenciaria-custodia-traslados-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1151, 1152],
        multiple_languages: false,
    },
    // 1151. Curso Vigilanca Penitenenciaria, Custodia y Traslados - ES
    {
        id: 1151,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilancia-penitenenciaria-custodia-traslados-2026-es",
        title: "Curso Vigilancia Penitenciaria, Custodia y Traslados",
        name: "Curso Vigilancia Penitenciaria, Custodia y Traslados",
        short: "1.) Vigilancia Penitenciaria, Custodia y Traslados",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1151/image1"],
        banner: ["/1151/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilancia-penitenenciaria-custodia-traslados-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1150,
        default_in_parent: true,
        evolmind: { course_id: 1225, group_id: [3073] },
    },
    // 1152. Curso Vigilanca Penitenenciaria, Custodia y Traslados - CA
    {
        id: 1152,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilancia-penitenenciaria-custodia-traslados-2026-ca",
        title: "Curs Vigilància Penitenciària, Custòdia i Trasllats",
        name: "Curs Vigilància Penitenciària, Custòdia i Trasllats",
        short: "1.) Vigilància Penitenciària, Custòdia i Trasllats",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1152/image1"],
        banner: ["/1152/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilancia-penitenenciaria-custodia-traslados-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1150,
        default_in_parent: true,
        evolmind: { course_id: 1228, group_id: [3076] },
    },
    // 1153. Curso Vigilantes Municipales I
    {
        id: 1153,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilantes-municipales-i-2026",
        title: "Curs Vigilants Municipals I",
        name: "Curs Vigilants Municipals I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació jurídica i institucional orientada a proporcionar els fonaments constitucionals, administratius i operatius necessaris per a l’exercici de les funcions pròpies dels vigilants municipals a Catalunya.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1153/image1"],
        banner: ["/1153/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilantes-municipales-i-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1154, 1155],
        multiple_languages: false,
    },
    // 1154. Curso Vigilantes Municipales I - ES
    {
        id: 1154,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilantes-municipales-i-2026-es",
        title: "Curso Vigilantes Municipales I",
        name: "Curso Vigilantes Municipales I",
        short: "1.) Vigilantes Municipales I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1154/image1"],
        banner: ["/1154/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilantes-municipales-i-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1153,
        default_in_parent: true,
        evolmind: { course_id: 1231, group_id: [3079] },
    },
    // 1155. Curso Vigilantes Municipales I - CA
    {
        id: 1155,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilantes-municipales-i-2026-ca",
        title: "Curs Vigilants Municipals I",
        name: "Curs Vigilants Municipals I",
        short: "1.) Vigilants Municipals I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1155/image1"],
        banner: ["/1155/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilantes-municipales-i-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1153,
        default_in_parent: true,
        evolmind: { course_id: 1234, group_id: [3082] },
    },
    // 1156. Curso Vigilantes Municipales II
    {
        id: 1156,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilantes-municipales-ii-2026",
        title: "Curs Vigilants Municipals II",
        name: "Curs Vigilants Municipals II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació avançada orientada a aprofundir en les competències jurídiques, sancionadores i operatives dels vigilants municipals, amb especial incidència en trànsit, procediment administratiu i actuació penal bàsica.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1156/image1"],
        banner: ["/1156/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilantes-municipales-ii-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1157, 1158],
        multiple_languages: false,
    },
    // 1157. Curso Vigilantes Municipales II - ES
    {
        id: 1157,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilantes-municipales-ii-2026-es",
        title: "Curso Vigilantes Municipales II",
        name: "Curso Vigilantes Municipales II",
        short: "1.) Vigilantes Municipales II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1156/image1"],
        banner: ["/1156/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilantes-municipales-ii-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1156,
        default_in_parent: true,
        evolmind: { course_id: 1237, group_id: [3085] },
    },
    // 1158. Curso Vigilantes Municipales II - CA
    {
        id: 1158,
        tax: 0.21,
        sku: "iopos.course.online.curso-vigilantes-municipales-ii-2026-ca",
        title: "Curs Vigilants Municipals II",
        name: "Curs Vigilants Municipals II",
        short: "1.) Vigilants Municipals II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1158/image1"],
        banner: ["/1158/image1"],
        link: "/tienda/cursos/formacion-policial/curso-vigilantes-municipales-ii-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1156,
        default_in_parent: true,
        evolmind: { course_id: 1240, group_id: [3088] },
    },
    // 1159. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 2
    {
        id: 1159,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g19-2",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 19] (07/02/26 15-20 h) [SEGON GRUP]",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 19] (07/02/26 15-20 h) [SEGON GRUP]",
        short: "19. Curs Preparació Tercera Prova Mossos 2026 [Grup 19] [07/02/26 15-20 h] [SEGON GRUP]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [3091],
        },
        limit: 30,
        sendPersonalityTestLink: true,
    },
    // 1160. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026
    {
        id: 1160,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g20",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 20] (10/02/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 20] (10/02/26 9-14 h)",
        short: "20. Curs Preparació Tercera Prova Mossos 2026 [Grup 20] [10/02/26 9-14 h]",
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [3094],
        },
        limit: 30,
        sendPersonalityTestLink: true,
    },
    // 1161. Curs Conducción Segura y Prevención de Accidentes (Policía)
    {
        id: 1161,
        tax: 0.21,
        sku: "iopos.course.online.curso-conduccion-segura-prevencion-accidentes-policia-2026",
        title: "Curs Conducció Segura i Prevenció d'Accidents (Policia)",
        name: "Curs Conducció Segura i Prevenció d'Accidents (Policia)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "Formació especialitzada orientada a reforçar la conducció segura, la prevenció d’accidents laborals viaris i la cultura de seguretat en serveis d’emergència i seguretat pública.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1161/image1"],
        banner: ["/1161/image1"],
        link: "/tienda/cursos/formacion-policial/curso-conduccion-segura-prevencion-accidentes-policia-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1162, 1163],
        multiple_languages: false,
    },
    // 1162. Curso Conducción Segura y Prevención de Accidentes (Policía) - ES
    {
        id: 1162,
        tax: 0.21,
        sku: "iopos.course.online.curso-conduccion-segura-prevencion-accidentes-policia-2026-es",
        title: "Curso Conducción Segura y Prevención de Accidentes (Policía)",
        name: "Curso Conducción Segura y Prevención de Accidentes (Policía)",
        short: "1.) Conducción Segura y Prevención de Accidentes (Policía)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1161/image1"],
        banner: ["/1161/image1"],
        link: "/tienda/cursos/formacion-policial/curso-conduccion-segura-prevencion-accidentes-policia-2026-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1161,
        default_in_parent: true,
        evolmind: { course_id: 1246, group_id: [3100] },
    },
    // 1163. Curso Conducción Segura y Prevención de Accidentes (Policía) - CA
    {
        id: 1163,
        tax: 0.21,
        sku: "iopos.course.online.curso-conduccion-segura-prevencion-accidentes-policia-2026-ca",
        title: "Curs Conducció Segura i Prevenció d'Accidents (Policia)",
        name: "Curs Conducció Segura i Prevenció d'Accidents (Policia)",
        short: "1.) Conducció Segura i Prevenció d'Accidents (Policia)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_ESPECIFICA_PARA_UNIDADES,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1161/image1"],
        banner: ["/1161/image1"],
        link: "/tienda/cursos/formacion-policial/curso-conduccion-segura-prevencion-accidentes-policia-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1161,
        default_in_parent: true,
        evolmind: { course_id: 1243, group_id: [3097] },
    },
    // 1164. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 2
    {
        id: 1164,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g21-2",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 21] (08/02/26 9-14 h) [SEGON GRUP]",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 21] (08/02/26 9-14 h) [SEGON GRUP]",
        short: "21. Curs Preparació Tercera Prova Mossos 2026 [Grup 21] [08/02/26 9-14 h] [SEGON GRUP]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [3103],
        },
        limit: 30,
        sendPersonalityTestLink: true,
    },
    // 1165. Guia Bàsica de la Preparació d'Entrevista per Mosso d'Esquadra
    {
        id: 1165,
        tax: 0.04,
        created_at: "2026-02-04 00:00:00",
        updated_at: "2026-02-04 00:00:00",
        sku: "iopos.book.guia-basica-preparacio-entrevista-mosso-esquadra-2026",
        title: "Guia Bàsica de la Preparació d'Entrevista per Mosso d'Esquadra",
        name: "Guia Bàsica de la Preparació d'Entrevista per Mosso d'Esquadra",
        description: "Domina l'entrevista de Mossos amb una guia clara, pràctica i realista per arribar-hi amb seguretat i marcar la diferència.",
        enabled: true,
        stock: true,
        stock_message: "Sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos],
        price: 19.99,
        offer: 29.99,
        offer_text: "Últimes unitats!",
        images: ["/1165/image1"],
        banner: ["/1165/image1"],
        shipment: 4.49,
        link: "/tienda/libros/guia-basica-preparacio-entrevista-mosso-esquadra-2026/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        weight: 200,
    },
    // 1166. Pack Físiques Sant Adrià del Besòs Arro - CEM Besòs
    {
        hidden: true,
        id: 1166,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-adria-entrenamiento-arro",
        title: "Pack Físiques Sant Adrià del Besòs - Entrenament Arro - CEM Besòs",
        name: "Pack Físiques Sant Adrià del Besòs - Entrenament Arro - CEM Besòs",
        description: "Pack d’entrenament presencial per preparar les proves físiques a Sant Adrià del Besòs (CEM Besòs) amb l’Entrenament Arro. Sessions guiades, treball de força, resistència i tècnica, amb seguiment per millorar resultats.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        discount_not_applicable: true,
        price: 14.99,
        shipment: 0.0,
        images: ["/1166/image1"],
        banner: ["/1166/image1"],
        link: "/tienda/cursos/pack-fisicas-sant-adria-entrenament-arro-2026/",
        created_at: "2026-02-04 00:00:10",
        start_at: "2026-02-04 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        childs: [1167],
    },
    // 1167. Pack Físiques Sant Adrià del Besòs Entrenament Arro - 1 Classe
    {
        hidden: true,
        id: 1167,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-adria-entrenament-arro-1-clase",
        title: "Pack Físiques Sant Adrià del Besòs Entrenament Arro - 1 Classe",
        name: "Pack Físiques Sant Adrià del Besòs Entrenament Arro - 1 Classe",
        short: "Pack 1 Classe - Entrenament Arro",
        description: "Pack d’entrenament presencial per preparar les proves físiques a Sant Adrià del Besòs (CEM Besòs) amb l’Entrenament Arro. Sessions guiades, treball de força, resistència i tècnica, amb seguiment per millorar resultats.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        price: 19.99,
        discount_not_applicable: true,
        shipment: 0.0,
        images: ["/1166/image1"],
        created_at: "2026-02-04 00:00:10",
        start_at: "2026-02-04 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        parent: 1166,
        calendly: {
            uuid: "be78b93f-42ce-4c5f-9426-63e7b849b784",
            units: 1,
        },
        disallow_multiple_units: true,
    },
    // 1168. Fase 1: Preparació d'Entrevista Policial - Policia Local (convocatòries vigents)
    {
        id: 1168,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.PL,
            product_types_1.Category.GUB,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase1-preparacio-entrevista-policial-policia-local-2026-1h30-ho",
        title: "Fase 1: Preparació d'Entrevista Policial - Policia Local 2026 (1:30 hores)",
        name: "Fase 1: Preparació d'Entrevista Policial - Policia Local 2026 (1:30 hores)",
        description: "Prepara l'entrevista de Policia Local amb una sessió 100% personalitzada i arriba-hi amb seguretat, criteri i respostes sòlides.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase1-preparacio-entrevista-policial-policia-local-2026-1h30-ho/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/1168/image2"],
        banner: ["/1168/image2"],
        link: "/tienda/cursos/fase1-preparacio-entrevista-policial-policia-local-2026-1h30-ho/",
        created_at: "2026-02-04 00:00:01",
        start_at: "2026-02-04 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            /*{
                id: 4,
                name: "Joan",
                position: "Psicòleg i policia local.",
                description: "Àmplia experiència en selecció de personal.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-joan/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },*/
            /*{
                id: 5,
                name: "Raul",
                position: "Policia Local",
                description:
                    "Agent i formador de la Guàrdia Urbana de Barcelona, especialista en competències policials catalanes.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-raul/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },*/
            {
                id: 2,
                name: "Jona",
                position: "",
                description: "Amplia experiencia profesional com a policia i especialista en casos práctics",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-jona/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },
            {
                id: 6,
                name: "Jordi",
                position: "Psicòleg col·legiat",
                description: "Rigor, criteri i domini dels barems d'avaluació.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-jordi/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },
            {
                id: 3,
                name: "Soufiane",
                position: "Caporal de Policia Local amb vocació de servei i lideratge.",
                description: "",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-soufiane/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },
            /*{
                id: 5,
                name: "Miguel",
                position: "Agent de Policia Local",
                description:
                    "Agent de referència en competències policials i servei públic, de la Policia Local més important de Catalunya.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-miguel/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },*/
            {
                id: 1,
                name: "Maite",
                position: "Caporala de la GUB i responsable de l'àrea de formació de PL a iOpos",
                description: "Visio policial, enfocament de l'entrevista desde la perspectiva del món local, potenciació de fortaleses i millora de les debilitats.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-maite/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },
            /*{
                id: 2,
                name: "Toni",
                position:
                    "Agent de Policia Local i formador de l'àrea de formació de PL a iOpos",
                description:
                    "Visio policial, enfocament de l'entrevista desde la perspectiva del món loca.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-toni/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },*/
            /*{
                id: 3,
                name: "Uri",
                position:
                    "Caporal de la Policia Local i formador a iOpos Acadèmia",
                description:
                    "Sessió amb l’Uri, caporal de la Policia Local de Castelldefels i formador a iOpos Visió Policial, orientada a potenciar els punts forts i reforçar les competències professionals dins la realitat municipal.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-oriol/fase-1-preparacio-entrevista-pl-2026-1-30-h-ho",
            },*/
        ],
    },
    // 1169. Fase 2: Simulacre d'Entrevista Policial - Policia Local (convocatòries vigents)
    {
        id: 1169,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.PL,
            product_types_1.Category.GUB,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE2,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase2-simulacre-entrevista-policial-policia-local-2026-1h-ho",
        title: "Fase 2: Simulacre d'Entrevista Policial - Policia Local 2026 (1:00 hores)",
        name: "Fase 2: Simulacre d'Entrevista Policial - Policia Local 2026 (1:00 hores)",
        description: "Fes el simulacre més realista abans del dia oficial i arriba a l'entrevista de Policia Local amb control, criteri i confiança total.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase2-simulacre-entrevista-policial-policia-local-2026-1h-ho/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/1169/image2"],
        banner: ["/1169/image2"],
        link: "/tienda/cursos/fase2-simulacre-entrevista-policial-policia-local-2026-1h-ho/",
        created_at: "2026-02-04 00:00:01",
        start_at: "2026-02-04 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            /*{
                id: 4,
                name: "Joan",
                position: "Psicòleg i policia local.",
                description: "Àmplia experiència en selecció de personal.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-joan/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },*/
            /*{
                id: 5,
                name: "Raul",
                position: "Policia Local",
                description:
                    "Agent i formador de la Guàrdia Urbana de Barcelona, especialista en competències policials catalanes.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-raul/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },*/
            {
                id: 2,
                name: "Jona",
                position: "",
                description: "Amplia experiencia profesional com a policia i especialista en casos práctics",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-jona/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },
            {
                id: 6,
                name: "Jordi",
                position: "Psicòleg col·legiat",
                description: "Rigor, criteri i domini dels barems d'avaluació.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-jordi/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },
            {
                id: 3,
                name: "Soufiane",
                position: "Caporal de Policia Local amb vocació de servei i lideratge.",
                description: "",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-soufiane/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },
            /*{
                id: 5,
                name: "Miguel",
                position: "Agent de Policia Local",
                description:
                    "Agent de referència en competències policials i servei públic, de la Policia Local més important de Catalunya.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-miguel/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },*/
            {
                id: 1,
                name: "Maite",
                position: "Caporala de la GUB i responsable de l'àrea de formació de PL a iOpos",
                description: "Visio policial, enfocament de l'entrevista desde la perspectiva del món local, potenciació de fortaleses i millora de les debilitats.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-maite/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },
            /*{
                id: 2,
                name: "Toni",
                position:
                    "Agent de Policia Local i formador de l'àrea de formació de PL a iOpos",
                description:
                    "Visio policial, enfocament de l'entrevista desde la perspectiva del món loca.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-toni/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },*/
            /*{
                id: 3,
                name: "Uri",
                position:
                    "Caporal de la Policia Local i formador a iOpos Acadèmia",
                description:
                    "Sessió amb l'Uri, caporal de la Policia Local de Castelldefels i formador a iOpos Visió Policial, orientada a potenciar els punts forts i reforçar les competències professionals dins la realitat municipal.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-oriol/fase-2-simulacre-entrevista-pl-2026-1-00-h-ho",
            },*/
        ],
    },
    // 1170. Fase 2: Simulacre d'Entrevista Policial + Campus - Policia Local (convocatòries vigents)
    {
        id: 1170,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.PL,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE2,
            product_types_1.Category.GUB,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase2-simulacre-entrevista-policial-policia-local-campus-2026-1h-ho",
        title: "Fase 2: Simulacre d'Entrevista Policial + Campus - Policia Local 2026 (1:00 hores)",
        name: "Fase 2: Simulacre d'Entrevista Policial + Campus - Policia Local 2026 (1:00 hores)",
        description: "Entrena l'entrevista real abans del dia oficial i reforça el teu criteri policial amb el Campus de Casos Pràctics: simulació + pràctica per arribar-hi al 100%.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase2-simulacre-entrevista-policial-policia-local-campus-2026-1h-ho/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 149.99,
        shipment: 0.0,
        images: ["/1170/image1"],
        banner: ["/1170/image1"],
        link: "/tienda/cursos/fase2-simulacre-entrevista-policial-policia-local-campus-2026-1h-ho/",
        created_at: "2026-02-04 00:00:01",
        start_at: "2026-02-04 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            /*{
                id: 4,
                name: "Joan",
                position: "Psicòleg i policia local.",
                description: "Àmplia experiència en selecció de personal.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-joan/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },*/
            /*{
                id: 5,
                name: "Raul",
                position: "Policia Local",
                description:
                    "Agent i formador de la Guàrdia Urbana de Barcelona, especialista en competències policials catalanes.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-raul/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },*/
            {
                id: 2,
                name: "Jona",
                position: "",
                description: "Amplia experiencia profesional com a policia i especialista en casos práctics",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-jona/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },
            {
                id: 6,
                name: "Jordi",
                position: "Psicòleg col·legiat",
                description: "Rigor, criteri i domini dels barems d'avaluació.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-jordi/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },
            {
                id: 3,
                name: "Soufiane",
                position: "Caporal de Policia Local amb vocació de servei i lideratge.",
                description: "",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-soufiane/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },
            /*{
                id: 5,
                name: "Miguel",
                position: "Agent de Policia Local",
                description:
                    "Agent de referència en competències policials i servei públic, de la Policia Local més important de Catalunya.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-miguel/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },*/
            {
                id: 1,
                name: "Maite",
                position: "Caporala de la GUB i responsable de l'àrea de formació de PL a iOpos",
                description: "Visio policial, enfocament de l'entrevista desde la perspectiva del món local, potenciació de fortaleses i millora de les debilitats.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-maite/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },
            /*{
                id: 2,
                name: "Toni",
                position:
                    "Agent de Policia Local i formador de l'àrea de formació de PL a iOpos",
                description:
                    "Visio policial, enfocament de l'entrevista desde la perspectiva del món loca.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-toni/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },*/
            /*{
                id: 3,
                name: "Uri",
                position:
                    "Caporal de la Policia Local i formador a iOpos Acadèmia",
                description:
                    "Sessió amb l’Uri, caporal de la Policia Local de Castelldefels i formador a iOpos Visió Policial, orientada a potenciar els punts forts i reforçar les competències professionals dins la realitat municipal.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-oriol/fase-2-simulacre-entrevista-campus-pl-2026-1-00-h-ho",
            },*/
        ],
        evolmind: {
            course_id: 78,
            group_id: [1887],
        },
    },
];
exports.default = products;
